import styled from 'styled-components';

export const FormContainer = styled.div`
  display: flex;
  .ant-form-item {
    width: 288px;
  }

  & > div {
    margin-right: 48px;
  }
`;

export const UploadWrapper = styled.div`
  & > div:last-child {
    margin-top: 26px;
  }
`;

export const AddTaskWrapper = styled.div`
  padding: 21px 0 13px;
  margin-top: 7px;
  border-top: 1px solid ${({ theme }: any) => theme.colors.grayVariations.medium};
`;
